<template>
  <el-upload
    class="avatar-uploader"
    :action="baseURL+'/api/mgr/upload/uploadFile'"
    :show-file-list="false"
    :on-success="uploadCallback"
    name="file" ref="upload"
    :limit="1" accept=".jpg,.png,jpeg,png,bmp,gif,tif"
    :before-upload="beforeAvatarUpload"
    :headers="headers"
  >
    <img v-if="imageUrl" :src="imageUrl.startsWith('http')?imageUrl:filePath+imageUrl"  :class="typeClass">
    <i v-else :class="'el-icon-plus '+typeIconClass"></i>
  </el-upload>
</template>

<script>
  export default {
    name: "upload-img",
    props:['modelValue','type'],
    data() {
      return {
        imageUrl:'',
        headers:{'token':localStorage.getItem("qc_token")},
        typeClass:'avatar',
        typeIconClass:' avatar-uploader-icon',
      }
    },
    watch:{
      modelValue:function(newValue){
        this.imageUrl = newValue;
      }
    },
    methods: {
      uploadCallback(response, file) {
        if(response.code==0){
          this.imageUrl = response.data.url;
          this.$emit("update:modelValue",this.imageUrl);
        }else{
          this.msgAlert(response.desc);
        }
        this.$refs.upload.clearFiles();
      },
      beforeAvatarUpload(file) {
        return this.validImage(file,function(){
          return true;
        });
      }
    },
    mounted() {
      this.imageUrl = this.modelValue;
      if(this.type&&this.type==2){
        this.typeClass = 'avatar-2';
        this.typeIconClass = 'avatar-uploader-icon-2';
      }else if(this.type&&this.type==3){
        this.typeClass = 'avatar-3';
        this.typeIconClass = 'avatar-uploader-icon-3';
      }else if(this.type&&this.type==4){
        this.typeClass = 'avatar-4';
        this.typeIconClass = 'avatar-uploader-icon-4';
      }else if(this.type&&this.type==5){
        this.typeClass = 'avatar-5';
        this.typeIconClass = 'avatar-uploader-icon-5';
      }
    }
  }
</script>


<style lang="less" scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #eeeeee;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #0071ef;
  }
  .avatar-uploader-icon {
    border: 1px solid #eeeeee;
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .avatar-uploader-icon-2 {
    border: 1px solid #eeeeee;
    font-size: 28px;
    color: #8c939d;
    width: 320px;
    height: 200px;
    line-height: 200px;
    text-align: center;
  }
  .avatar-2 {
    width: 320px;
    height: 200px;
    display: block;
  }

  .avatar-3 {
    width: 50px;
    height: 50px;
    display: block;
  }
  .avatar-uploader-icon-3 {
    border: 1px solid #eeeeee;
    font-size: 14px;
    color: #8c939d;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }

  .avatar-uploader-icon-4 {
    border: 1px solid #eeeeee;
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
    border-radius: 50%;
  }
  .avatar-4 {
    width: 178px;
    height: 178px;
    display: block;
    border-radius: 50%;
  }

  .avatar-uploader-icon-5 {
    border: 1px solid #eeeeee;
    font-size: 28px;
    color: #8c939d;
    width: 160px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar-5 {
    width: 160px;
    height: 100px;
    display: block;
  }
</style>
